import _assign from "lodash/assign";
import _reduce from "lodash/reduce";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @typedef {object} MonthlyBudget
 * @property {number} debtToIncome  your current dti
 * @property {number} housingToIncome  max dti you can take - your current dti @todo what??
 * @property {number} taxesToIncome  your current tax rate
 * @property {number} restToIncome  the rest, 1 - tax rate - max dti you can take
 * @property {number} monthlyIncome  monthly income
 * @property {number} taxes  monthly taxes
 * @property {number} rest  the rest, remaining monthly income after tax and (max dti you can take * monthly income)
 */

/**
 * Find the delta between adjustedOutputs and outputs for every item in monthlyBudget.
 * @module calculate-budget-delta
 * @param {object} state Entire reducer state
 * @param {object} state.outputs Outputs of calculation
 * @param {MonthlyBudget} state.outputs.monthlyBudget Collection of monthly budget values
 * @param {object} state.adjustedOutputs Adjusted outputs?
 * @param {MonthlyBudget} state.adjustedOutputs.monthlyBudget Collection of monthly budget values
 * @returns {MonthlyBudget} `{ monthlyBudget: MonthlyBudget }`
 * @example
 * import calculateBudgetDelta from '@nerdwallet/calculate-home-affordability/calculate-budget-delta';
 *
 * const delta = calculateBudgetDelta({
 *   adjustedOutputs: {
 *     monthlyBudget: {
 *       debtToIncome: 0.5,
 *       housingToIncome: 0.5,
 *       taxesToIncome: 0.5,
 *       restToIncome: 0.5,
 *       monthlyIncome: 1000,
 *       taxes: 500,
 *       rest: 500,
 *     },
 *   },
 *   outputs: {
 *     monthlyBudget: {
 *       debtToIncome: 0.5,
 *       housingToIncome: 0.5,
 *       taxesToIncome: 0.5,
 *       restToIncome: 0.5,
 *       monthlyIncome: 1000,
 *       taxes: 500,
 *       rest: 500,
 *     },
 *   },
 * });
 */
export default function calculateBudgetDelta(_ref) {
  var monthlyBudget = _ref.outputs.monthlyBudget,
      adjustedMonthlyBudget = _ref.adjustedOutputs.monthlyBudget;

  var monthlyBudgetDelta = _reduce(monthlyBudget, function (result, value, key) {
    return _assign({}, result, _defineProperty({}, key, adjustedMonthlyBudget[key] - value));
  }, {});

  monthlyBudgetDelta.housing = Math.max(0, -monthlyBudgetDelta.rest);
  monthlyBudgetDelta.housingToIncome = Math.max(0, -monthlyBudgetDelta.restToIncome);
  return {
    monthlyBudget: monthlyBudgetDelta
  };
}